import PopoverTemplate from '@nkr/components/popover-template';
import { IMicrositeRecipientForList } from '@nkr/models/index';
import { MicrositeEventType, MicrositeListType, MicrositeRecipientStatus } from '@nkr/enums/index';
import { ICellRendererParams } from 'ag-grid-community';
import { Glyphicon, Label, OverlayTrigger } from 'react-bootstrap';
import { transplantEventTypes } from '@nkr/enums/microsite-event-type';

const getOverlay = (data: IMicrositeRecipientForList) => {
    let isTransplantedTypes = [...transplantEventTypes, MicrositeEventType.ReceivedVoucher ];
    let event = data.micrositeEventLogs.sort((a, b) => new Date(b.eventDate).getTime() - new Date(a.eventDate).getTime()).find(x => isTransplantedTypes.indexOf(x.eventType))
    let transferredCtrEvent = data.micrositeEventLogs.sort((a, b) => new Date(b.eventDate).getTime() - new Date(a.eventDate).getTime()).find(x => x.eventType == MicrositeEventType.MovedNewCenter)
    
    let isTransplanted = event != null;
    return (
        <PopoverTemplate id="alertpop">
            <div style={{ marginBottom: 5, fontWeight: 700, fontSize: 16, minWidth: 300 }}>{data.firstName} {data.lastName}</div>

            {data.deactivationDetails.reason != '' && (data.currentStatusId == MicrositeRecipientStatus.Inactive || (transferredCtrEvent != null && transferredCtrEvent.newCenterId != data.centerId)) && (
                <>
                    <div style={{ fontWeight: 500 }}>Reason</div>
                    <div style={{ marginBottom: 5 }}>{data.deactivationDetails.reason}</div>
                </>
            )}

            data.
            {isTransplanted && (
                <>
                    {data.deactivationDetails.transplantDate != '' && (
                        <>
                            <div style={{ fontWeight: 500 }}>Transplant Date</div>
                            <div style={{ marginBottom: 5 }}>{data.deactivationDetails.transplantDate}</div>
                        </>
                    )}

                    <div style={{ fontWeight: 500 }}>Transplanted From DASH</div>
                    <div style={{ marginBottom: 5 }}>{data.deactivationDetails.transplantedFromDashRegistration ? 'Yes' : 'No'}</div>

                    {(event.eventType == MicrositeEventType.ReceivedDeceasedKidney || event.eventType == MicrositeEventType.ReceivedDeceasedKidneyOtherCenter) && (
                        <>
                            <div style={{ fontWeight: 500 }}>Type of Transplant</div>
                            <div>Deceased Donor</div>
                        </>
                    )}

                    {event.eventType == MicrositeEventType.ReceivedLivingKidney && (
                        <>
                            <div style={{ fontWeight: 500 }}>Type of Transplant</div>
                            <div>Living Donor - Microsite Center</div>
                        </>
                    )}
                </>
            )}
        </PopoverTemplate>
    );
};

export const WeeklyEmailRenderer = (params: ICellRendererParams) => {
    return (
        <>
            {params.value && (
                <Glyphicon glyph='ok' />
            )}
        </>
    );
}

export const StatusRenderer = (params: ICellRendererParams) => {
    let data = params.data as IMicrositeRecipientForList;
    var isCustomSite = data.currentStatusId == MicrositeRecipientStatus.Active;

    if(isCustomSite)
    {
        let statusDesc = data.customSiteStatusDescription;
            return (
                    <span style={{ color: 'black', fontSize: 12 }}>{statusDesc}</span>
            );
    }
    else {
        //determine if should be a starter site or custom site status

        var value = "";
        value += data.customSiteStatusId > 0 
            ? data.customSiteStatusDescription
            : params.value;

        if (data.deactivationDetails != null) {
            return (
                <OverlayTrigger placement='left' trigger={['click']} overlay={getOverlay(data)} rootClose={true} animation={true} >
                    <a style={{ color: 'black', fontSize: 12 }}>{params.value}</a>
                </OverlayTrigger>
            );
        }
    
        return <div style={{ fontSize: 12 }}>{value}</div>;
    }
}



export const PostTransplantBannerStatusRenderer = (params: ICellRendererParams) => {
    let data = params.data as IMicrositeRecipientForList;
    var bannerStatus = data.micrositeBannerStatusId;
    var bannerStatusDesc = data.micrositeBannerStatusDesc;
    let style = "";

    switch(bannerStatus)
    {
        case 0: 
            bannerStatusDesc = "--";
        break;

        case 1:
            style = "default";
        break;

        case 2:
            style = "success";
        break;
        case 3:
            style = "success";
        break;
    }

    return (
        <Label bsStyle={style} style={{ fontSize: 12 }}>{bannerStatusDesc}</Label>
    );
}

export const RowNumberRenderer = (params) => {
    return <>{params.rowIndex + 1}</>
}
